import React from 'react';
import {editCompanyReminderConfigs} from "../../../../../../../services/company/api";
import Translate, {t} from "../../../../../../../components/Translate";
import config from "../../../../../../../config";
import Input from "../../../../../../../components-new/Input";

const ReminderSettings = ({features, client, user, reminderData, setReminderData}) => {
    const handleReminderDataChange = (e) => {
        const {name, value, type, checked} = e.target;
        const updatedData = {...reminderData, [name]: type === 'checkbox' ? checked : value};

        const isIntervalValid = updatedData.interval >= 10 && updatedData.interval <= 1000;
        const isCountValid = updatedData.count >= 0 && updatedData.count <= 10;

        setReminderData(updatedData);
        if (isIntervalValid && isCountValid) {
            editCompanyReminderConfigs(client.id, updatedData);
        }
    };

    return (
        <div style={{padding: '5px', margin: '10px', display: 'flex', flexDirection: 'column', gap: '8px'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '20px'}}>
                <h2 style={{fontSize: '16px', color: 'rgb(164, 173, 193)', marginBottom: '20px'}}>
                    <Translate text={'reminderSettings'}/>
                </h2>
                <label style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
                    <input
                        type="checkbox"
                        name="enabled"
                        checked={reminderData.enabled}
                        onChange={handleReminderDataChange}
                        style={{marginRight: '5px'}}
                    />
                </label>
            </div>

            {reminderData.enabled && (
                <React.Fragment>
                    <label style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                        <Translate text={'message'}/>:
                        <select
                            name="type"
                            value={reminderData.type}
                            onChange={handleReminderDataChange}
                            style={{
                                display: 'block',
                                width: '250px',
                                marginTop: '10px',
                                backgroundColor: 'white',
                                border: '1px solid rgb(221, 221, 221)',
                                fontSize: '16px',
                                padding: '10px',
                                borderRadius: '10px',
                                marginBottom: '10px',
                                marginLeft: '10px'
                            }}
                        >
                            <option value="FROM_HARDCODED_MESSAGES">{t({
                                text: "fromHardcodedMessages",
                                user
                            })}</option>

                        </select>
                    </label>
                    <label style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                        <Translate text={'interval_sec'}/>:
                        <Input
                            type="number"
                            name="interval"
                            value={reminderData.interval}
                            style={{marginLeft: '10px', padding: '4px', width: '100px'}}
                            onChange={handleReminderDataChange}
                            min={10}
                        />
                    </label>
                    <label style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                        <Translate text={'count'}/>:
                        <Input
                            style={{marginLeft: '10px', padding: '4px', width: '100px'}}
                            type="number"
                            name="count"
                            value={reminderData.count}
                            onChange={handleReminderDataChange}
                            max={10}
                            min={0}
                        />
                    </label>
                </React.Fragment>
            )}


        </div>
    );
};

export default ReminderSettings;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/ReminderSettings.jsx